/**
  Get data from extra info
  @param {object} chatbot Chatbot SDK adapter
  @param {string} cb      callback function
 */
function getConfigExtraInfo(chatbot, cb) {
  const config = {};
  chatbot.api.getAppData({
    dataID: 'config',
    name: ''
  }).then(response => {
    if (response.data.results) {
      response.data.results.forEach((configItem) => {
        config[configItem.name] = configItem.value;
      });
      cb(config);
    }
    cb(null);
  });
}

export { getConfigExtraInfo };
